import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";

interface CTASectionProps {
  onReferClient: () => void;
  className?: string;
  isMobile?: boolean;
}

export function CTASection({ onReferClient, className = "", isMobile = false }: CTASectionProps) {
  return (
    <Card className={`border border-gray-200 bg-white ${isMobile ? "" : "flex-1"} ${className}`}>
      <CardContent className={isMobile ? "p-3 sm:p-4 flex flex-col justify-center" : "p-6 h-full flex flex-col justify-center"}>
        <Button 
          variant="primary"
          onClick={onReferClient}
          className="w-full mb-2"
          size="lg"
        >
          Refer a Company
        </Button>
        <p className={`${isMobile ? "text-fluid-sm" : "text-sm"} text-center text-gray-600 normal-case tracking-normal ${isMobile ? "mt-4" : "mt-3"}`}>
          Know a company that needs great talent? Refer them to our platform and earn rewards when they become hiring partners.
        </p>
      </CardContent>
    </Card>
  );
}
